<ng-container *transloco="let t; prefix: 'PremiseHazard'">
  <form [formGroup]="ContactForm" class="msi-margin-s">
    <label class="msi-label">{{ t('label.contactName') }}</label>
    <div class="input-container msi-margin-s">
      <input pInputText class="textInput full-width-input" placeholder="{{ t('placeholder.contactName') }}" formControlName="name" />
    </div>
    <div formArrayName="devices" class="msi-margin-s">
      @for (device of ContactForm.get('devices')?.value; track trackByDeviceIndex(deviceIdx, device); let deviceIdx = $index) {
        <div>
          <div [formGroupName]="deviceIdx">
            <div class="row-with-cancel-icon">
              <button type="button" pButton [text]="true" [rounded]="true" [ariaLabel]="t('Item.modal.removeDevice.header')" (click)="removeDevice(deviceIdx)"><msi-icon name="ic_remove" [size]="14" class="delete-icon" /></button>
              {{ t('label.device') }} {{ deviceIdx + 1 }}
            </div>
            <div class="form-column">
              <label class="msi-label">{{ t('label.deviceType') }}</label>
              <div class="input-container">
                <p-select class="msi-margin-s full-width-input" placeholder="{{ t('placeholder.deviceType') }}" formControlName="deviceType" [options]="DEVICE_TYPES">
                  <ng-template pTemplate="selectedItem" let-value>{{ value | titlecase }}</ng-template>
                  <ng-template pTemplate="item" let-opt>{{ opt | titlecase }}</ng-template>
                </p-select>
              </div>
            </div>
            <div class="form-column">
              @if (!device.deviceType) {
                <div>
                  <label class="msi-label">{{ t('label.deviceAddress') }}</label>
                </div>
              }
              @if (device.deviceType && device.deviceType.toString().localeCompare('email', undefined, { sensitivity: 'base' , caseFirst: 'lower' }) === 0) {
                <div>
                  <label class="msi-label">{{ 'Terms.emailAddress' | transloco }}</label>
                </div>
              }
              @if (device.deviceType && device.deviceType.toString().localeCompare('email', undefined, { sensitivity: 'base' , caseFirst: 'lower' }) !== 0) {
                <div>
                  <label class="msi-label">{{ 'Terms.phoneNumber' | transloco }}</label>
                </div>
              }
              <div class="input-container">
                <input pInputText class="msi-margin-s full-width-input" placeholder="{{ t('placeholder.deviceAddress') }}" formControlName="address" />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div>
      <button type="button" pButton class="msi-margin-m" (click)="addDevice()"><msi-icon name="ic_add" />{{ t('Item.button.addDevice') }}</button>
    </div>
    <div class="form-row-bottom">
      <button type="button" pButton class="msi-margin-s" (click)="submit()" [disabled]="!ContactForm.valid">
        <msi-icon name="ic_add" />{{ 'Buttons.add' | transloco }}
      </button>
      <button type="button" pButton class="msi-margin-s" (click)="cancel()">
        <msi-icon name="ic_remove" class="delete-icon" />{{ 'Buttons.cancel' | transloco }}
      </button>
    </div>
  </form>
</ng-container>
